import { render } from "./carruselComponent.vue?vue&type=template&id=038eb476&scoped=true"
import script from "./carruselComponent.vue?vue&type=script&lang=js"
export * from "./carruselComponent.vue?vue&type=script&lang=js"

import "./carruselComponent.vue?vue&type=style&index=0&id=038eb476&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038eb476"]])

export default __exports__